var _ = require('lodash');
var commonServiceHandlerConfig = require('swa-app-configuration/common-service-status-handler-config');
var http503StatusCodeHandler = require('../http-503-status-code-handler');
var serviceStatusHandler = require('swa-service/service-status-handler');

serviceStatusHandler.setConfig(_.extend({}, commonServiceHandlerConfig, {
    503: http503StatusCodeHandler
}));
